import React, { useState } from 'react';

const ENQUIRY_ENDPOINT = 'https://formsubmit.co/ajax/sales@zyvoralifesciences.com';

const initialState = {
  name: '',
  email: '',
  phone: '',
  company: '',
  location: '',
  message: ''
};

function LeadForm({ formType = 'General Inquiry', submitLabel = 'Submit Enquiry', compact = false, onSuccess }) {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const formId = formType.toLowerCase().replace(/[^a-z0-9]+/g, '-');

  const validate = () => {
    const nextErrors = {};

    if (!formData.name.trim()) nextErrors.name = 'Name is required.';

    if (!formData.email.trim()) {
      nextErrors.email = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      nextErrors.email = 'Enter a valid email address.';
    }

    if (!formData.phone.trim()) {
      nextErrors.phone = 'Phone number is required.';
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      nextErrors.phone = 'Enter a valid 10-digit Indian mobile number.';
    }

    if (!formData.message.trim()) nextErrors.message = 'Please enter your message.';

    return nextErrors;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    setSubmitError('');

    if (Object.keys(validationErrors).length > 0) {
      setIsSubmitted(false);
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = new FormData();
      Object.entries(formData).forEach(([key, value]) => payload.append(key, value));
      payload.append('form_type', formType);
      payload.append('_subject', `${formType} from Zyvora Life Sciences 9 website`);
      payload.append('_captcha', 'false');
      payload.append('_template', 'table');

      const response = await fetch(ENQUIRY_ENDPOINT, {
        method: 'POST',
        body: payload,
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Failed to send enquiry.');

      setIsSubmitted(true);
      setFormData(initialState);
      if (onSuccess) onSuccess();
    } catch (error) {
      setIsSubmitted(false);
      setSubmitError('We could not send your enquiry right now. Please try again in a moment.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className={`contact-form ${compact ? 'compact-form' : ''}`} onSubmit={handleSubmit} noValidate>
      <div className="form-grid">
        <div>
          <label htmlFor={`${formId}-name`}>Name</label>
          <input id={`${formId}-name`} name="name" type="text" value={formData.name} onChange={handleChange} />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>
        <div>
          <label htmlFor={`${formId}-phone`}>Phone</label>
          <input id={`${formId}-phone`} name="phone" type="tel" value={formData.phone} onChange={handleChange} />
          {errors.phone && <span className="error-text">{errors.phone}</span>}
        </div>
      </div>

      <label htmlFor={`${formId}-email`}>Email</label>
      <input id={`${formId}-email`} name="email" type="email" value={formData.email} onChange={handleChange} />
      {errors.email && <span className="error-text">{errors.email}</span>}

      {!compact && (
        <div className="form-grid">
          <div>
            <label htmlFor={`${formId}-company`}>Company / Farm</label>
            <input id={`${formId}-company`} name="company" type="text" value={formData.company} onChange={handleChange} />
          </div>
          <div>
            <label htmlFor={`${formId}-location`}>Location</label>
            <input id={`${formId}-location`} name="location" type="text" value={formData.location} onChange={handleChange} />
          </div>
        </div>
      )}

      <label htmlFor={`${formId}-message`}>Requirement</label>
      <textarea id={`${formId}-message`} name="message" rows={compact ? '3' : '4'} value={formData.message} onChange={handleChange} />
      {errors.message && <span className="error-text">{errors.message}</span>}

      <button type="submit" className="btn primary" disabled={isSubmitting}>
        {isSubmitting ? 'Sending...' : submitLabel}
      </button>

  {isSubmitted && (
  <p className="success-text">
    Thank you! Our team will contact you shortly.
  </p>
)}

{submitError && (
  <>
    <p className="error-text">
      We could not send your enquiry right now.
    </p>

    <div className="whatsapp-fallback">
      <p className="whatsapp-text">
        Need a faster response?
      </p>

      <a
        href="https://wa.me/919868510836?text=Hello%20Zyvora%20Life%20Sciences,%20I%20would%20like%20to%20know%20more%20about%20your%20livestock%20nutrition%20products."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
      >
        Chat on WhatsApp
      </a>
    </div>
  </>
)}
    </form>
  );
}

export default LeadForm;
